export default __webpack_public_path__ + "static/Mark-5-642a50b629498f56053cc2ced9e9d931.jpg";